module.exports = __webpack_public_path__ + "static/media/DataBase_Files.H03.2bb25366.png";